module.exports = __webpack_public_path__ + "img/img_banner_system.28ce7e8c.jpg";